import { render, staticRenderFns } from "./LandingClients.vue?vue&type=template&id=741c06de"
import script from "./LandingClients.vue?vue&type=script&lang=js"
export * from "./LandingClients.vue?vue&type=script&lang=js"
import style0 from "./LandingClients.vue?vue&type=style&index=0&id=741c06de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports